<fieldset [formGroup]="parentFormGroup">
  <legend>
    <div>
      <span i18n>Restricted roles with access to this bookable item</span>
      <div>
        @if (itemTreeExtraRolesForm.value.length > 0) {
          <eas-editor-booking-item-inheritable-type-badge [inheritableType]="'set'">
          </eas-editor-booking-item-inheritable-type-badge>
        }
        @if (isDeletable()) {
          <button
            mat-icon-button
            aria-label="Delete restricted roles"
            i18n-aria-label
            (click)="onDelete()">
            <mat-icon inline>delete</mat-icon>
          </button>
        }
      </div>
    </div>
  </legend>
  <p i18n>
    Roles with the relevant permissions to manage bookings are able to view bookings across the system.
    <br>
    Are there any additional roles which should be given access to manage bookings for this item?
  </p>
    <div class="form-container">
      <mat-form-field appearance="outline">
        <mat-label i18n>Restricted roles</mat-label>
        <mat-select id="extra-roles" multiple formControlName="extraRoles">
          @for (option of roleNames; track option) {
            <mat-option [value]="option.id" [title]="option.name">
              {{ option.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </fieldset>
